/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Faq } from 'ui/atoms/Faq/Faq';
import { OurCustomersV2 } from 'ui/molecules/OurCustomers/OurCustomersV2';
import { AccessRoutes } from 'ui/organisms/AccessRoutes/AccessRoutes';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';
import { DifferenceSection } from 'ui/organisms/DifferenceSection/DifferenceSection';
import { NumberedFeatureCards } from 'ui/organisms/NumberedFeatureCards/NumberedFeatureCards';

import { FinancialServicesCompare } from 'landing-pages/financial-services/sections/FinancialServicesCompare/FinancialServicesCompare';
import { FinancialServicesHero } from 'landing-pages/financial-services/sections/FinancialServicesHero/FinancialServicesHero';
import { FinancialServicesProblems } from 'landing-pages/financial-services/sections/FinancialServicesProblems/FinancialServicesProblems';
import { FinancialServicesQuote } from 'landing-pages/financial-services/sections/FinancialServicesQuote/FinancialServicesQuote';

import styles from './FinancialServicesPage.module.scss';

import { getAccessRoutes, getChallengerItems, getFaqItems, getLifecycleItems } from './data';

export const FinancialServicesPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <FinancialServicesHero />
      <OurCustomersV2 hasBackground={false} />
      <NumberedFeatureCards
        title={t('Every field carries its source, its filing, and its timestamp.')}
        columns={3}
        background="#042354"
        items={getChallengerItems(t)}
      />
      <FinancialServicesProblems />
      <DifferenceSection items={getLifecycleItems(t)} title={t('From first check to last review, on one dataset.')} />
      <FinancialServicesCompare />
      <FinancialServicesQuote />
      <AccessRoutes
        background="navy"
        heading={t('How to access the data.')}
        lede={t('Five routes into the same primary, government-sourced dataset — pick the one that fits your stack.')}
        routes={getAccessRoutes(t)}
      />
      <CtaSection
        spotlight
        title={t("Bring your hardest counterparties to the call. We'll trace them to source.")}
        description={t(
          "Give us a company name or number. You'll see the record, the registries behind it, and the audit trail your compliance team has been asking for.",
        )}
        actions={
          <>
            <Button href="/book-a-demo" type="blue" size="xl" suffixIcon="arrow-forward">
              {t('Book a demo')}
            </Button>
            <Button href="/free-trial" type="dark-outline" size="xl">
              {t('Start a free trial')}
            </Button>
          </>
        }
      />
      <Faq title={t('The questions a risk committee asks.')} data={getFaqItems(t)} />
    </div>
  );
};
